import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=de33e660&scoped=true&"
import script from "./ProgramList.vue?vue&type=script&lang=js&"
export * from "./ProgramList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramList.vue?vue&type=style&index=0&id=de33e660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de33e660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VList,VListItem,VListItemAction,VListItemGroup,VListItemTitle})
